import { render } from "./FundraisingCard.vue?vue&type=template&id=4725e6d3"
import script from "./FundraisingCard.vue?vue&type=script&lang=js"
export * from "./FundraisingCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__